export class FiltroConsultaHab{
    constructor(
        public startDate?:string,
        public endDate?:string,
        public nroPersonas?:number
    ){ }
}